import {
  TableCell as MuiTableCell,
  type TableCellProps as MuiTableCellProps,
  Tooltip,
  type TooltipProps,
  Typography,
  type TypographyProps,
} from "@mui/material";
import { type VFC } from "react";

import { useConditionalTooltip } from "../../hooks";

/** @deprecated We are phasing out `cc-ui` */
export interface StringContentProps {
  tooltip?: TooltipProps["title"];
  typographyProps: TypographyProps;
  value: string;
}

/** @deprecated We are phasing out `cc-ui` */
export const StringContent: VFC<StringContentProps> = ({ tooltip, typographyProps, value }) => {
  const { ref, shouldShow } = useConditionalTooltip<HTMLTableCellElement>();
  return (
    <Tooltip arrow disableHoverListener={!shouldShow} title={<>{tooltip || value}</>}>
      <Typography ref={ref} {...typographyProps}>
        {value}
      </Typography>
    </Tooltip>
  );
};

/** @deprecated We are phasing out `cc-ui` */
export interface TableCellProps {
  ref?: React.Ref<HTMLTableCellElement | null>;
  tableCellProps?: MuiTableCellProps;
  typographyProps?: TypographyProps;
  value?: React.ReactNode;
  tooltip?: string;
}

export const TableCell: VFC<TableCellProps> = ({ tableCellProps = {}, typographyProps = {}, value, tooltip }) => {
  return (
    <MuiTableCell {...tableCellProps} className={tableCellProps.className}>
      {typeof value === "string" ? (
        <StringContent tooltip={tooltip} typographyProps={typographyProps} value={value} />
      ) : (
        <>{value}</>
      )}
    </MuiTableCell>
  );
};

/** @deprecated We are phasing out `cc-ui` */
export default TableCell;
